module.exports = {"svg":{"$":{"width":"128","height":"128","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M0 54.857h36.571V128H0V54.857zM91.429 27.43H128V128H91.429V27.429zM45.714 0h36.572v128H45.714V0z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/chart.svg
// module id = 367
// module chunks = 0